module.exports = __webpack_public_path__ + "static/media/logo-arbre-63px.590f00c9.png";